'use client'

import TextField from './Input/Text'

import CheckboxField from './Checkbox'
import RadioField from './Radio'
import RangeField from './Range'
import SelectSearchField from './Select'

export const Input = {
  Text: TextField
}

export const Select = SelectSearchField
export const Checkbox = CheckboxField
export const Radio = RadioField
export const Range = RangeField
